__turbopack_context__.v({
  "focusRing": "focusRing-module__uBuSYa__focusRing",
});
